import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

const OutlinedIconButton = styled(IconButton)({
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    height: 40,
    width: 40,
    padding: 2,
    '&:not(:last-child)': {
        marginRight: 8,
    },
    '& svg': {
        width: '18px',
        height: '18px',
        '& path': {
            fill: 'var(--text-secondary)',
        },
    },
});

export default OutlinedIconButton;
